import { Pack, Muse } from '../types';
import * as Muses from '../shared/assets/images/muses';

export const PACKS: Record<string, Pack> = {
  // Seasonal: Winter 2026 - Blizzard Beats
  "Snow Puppies": {
    name: 'Snow Puppies',
    price: 100,
    description: 'Cozy winter pups.',
    seasonalGroup: 'Winter 2026',
    releaseAt: '2025-12-07T00:00:00-05:00',
    endAt: '2026-03-31T23:59:59-05:00',
    muses: [
      { name: 'snow retriever', img: Muses.SnowPuppies_retriever, rarity: 'Common', weight: 60 },
      { name: 'snow shepherd', img: Muses.SnowPuppies_shepherd, rarity: 'Uncommon', weight: 25 },
      { name: 'snow corgi', img: Muses.SnowPuppies_corgi, rarity: 'Rare', weight: 10 },
      { name: 'snow frenchy', img: Muses.SnowPuppies_frenchy, rarity: 'Epic', weight: 4 },
      { name: 'snow beagle', img: Muses.SnowPuppies_beagle, rarity: 'Legendary', weight: 1 },
    ],
    dropRates: [60, 25, 10, 4, 1]
  },
  // Seasonal: Fall 2025
  "Spooky Pack": {
    name: 'Spooky Pack',
    price: 100,
    description: 'Creepy-cute legends for Fall!',
    seasonalGroup: 'Fall 2025',
    releaseAt: '2025-09-29T00:00:00-04:00',
    endAt: '2025-12-06T23:59:59-05:00',
    muses: [
      { name: 'spidey', img: Muses.Spooky_spidey, rarity: 'Common', weight: 60 },
      { name: 'beary', img: Muses.Spooky_beary, rarity: 'Uncommon', weight: 25 },
      { name: 'zombie', img: Muses.Spooky_zombie, rarity: 'Rare', weight: 10 },
      { name: 'hoodie', img: Muses.Spooky_hoodie, rarity: 'Epic', weight: 4 },
      { name: 'shadow royalty', img: Muses.Spooky_lordly, rarity: 'Legendary', weight: 1 },
    ],
    dropRates: [60, 25, 10, 4, 1]
  },
  "Leafy Heroes Pack": {
    name: 'Leafy Heroes Pack',
    price: 200,
    description: 'The heroic side of autumn! ',
    seasonalGroup: 'Fall 2025',
    releaseAt: '2025-10-13T00:00:00-04:00',
    endAt: '2025-12-06T23:59:59-05:00',
    muses: [
      { name: 'drummy car', img: Muses.LeafyHeroes_drummy_car, rarity: 'Common', weight: 60 },
      { name: 'apple sax', img: Muses.LeafyHeroes_apple_sax, rarity: 'Uncommon', weight: 25 },
      { name: 'acorn kazoo', img: Muses.LeafyHeroes_acorn_kazoo, rarity: 'Rare', weight: 10 },
      { name: 'violeaf', img: Muses.LeafyHeroes_violeaf, rarity: 'Epic', weight: 4 },
      { name: 'squash pipes', img: Muses.LeafyHeroes_squash_pipes, rarity: 'Legendary', weight: 1 },
    ],
    dropRates: [60, 25, 10, 4, 1]
  },
  "K-pop Pack": {
    name: 'K-pop Pack',
    price: 300,
    description: 'Idol energy, autumn edition!',
    seasonalGroup: 'Fall 2025',
    releaseAt: '2025-10-27T00:00:00-04:00',
    endAt: '2025-12-06T23:59:59-05:00',
    muses: [
      { name: 'mic', img: Muses.Kpop_mic, rarity: 'Common', weight: 60 },
      { name: 'ramen', img: Muses.Kpop_ramen, rarity: 'Uncommon', weight: 25 },
      { name: 'hat bird', img: Muses.Kpop_hat_bird, rarity: 'Rare', weight: 10 },
      { name: 'hot sauce', img: Muses.Kpop_hot_sauce, rarity: 'Epic', weight: 4 },
      { name: 'derpy cat', img: Muses.Kpop_derpy_cat, rarity: 'Legendary', weight: 1 },
    ],
    dropRates: [60, 25, 10, 4, 1]
  },
  "Leafy Bad Guys Pack": {
    name: 'Leafy Bad Guys Pack',
    price: 400,
    description: 'Mischief rustles through the leaves!',
    seasonalGroup: 'Fall 2025',
    releaseAt: '2025-11-10T00:00:00-05:00',
    endAt: '2025-12-06T23:59:59-05:00',
    muses: [
      { name: 'flashy cat', img: Muses.LeafyBadGuys_flashy_cat, rarity: 'Common', weight: 60 },
      { name: 'chad capybara', img: Muses.LeafyBadGuys_chad_capybara, rarity: 'Uncommon', weight: 25 },
      { name: 'pumpkinini sharkinini', img: Muses.LeafyBadGuys_pumpkinini_sharkinini, rarity: 'Rare', weight: 10 },
      { name: 'silencio', img: Muses.LeafyBadGuys_silencio, rarity: 'Legendary', weight: 4 },
    ],
    dropRates: [60, 25, 10, 4]
  },
  "Grand Finale Pack": {
    name: 'Grand Finale Pack',
    price: 500,
    description: 'The grand autumn send-off!',
    seasonalGroup: 'Fall 2025',
    releaseAt: '2025-11-24T00:00:00-05:00',
    endAt: '2025-12-06T23:59:59-05:00',
    muses: [
      { name: 'fall songly', img: Muses.Finale_fall_songly, rarity: 'Common', weight: 60 },
      { name: 'wizard songly', img: Muses.Finale_wizard_songly, rarity: 'Uncommon', weight: 25 },
      { name: 'blobby', img: Muses.Finale_blobby, rarity: 'Legendary', weight: 15 },
    ],
    dropRates: [60, 25, 15]
  },
  "Cyclops Pack": {
    name: 'Cyclops Pack',
    price: 10,
    description: 'One-eyed wonders from all worlds!',
    muses: [
      { name: 'Cyclops', img: Muses.Eye, rarity: 'Common', weight: 60 },
      { name: 'Underwater Cyclops', img: Muses.UnderwaterRobotEye, rarity: 'Uncommon', weight: 25 },
      { name: 'Robot Cyclops', img: Muses.RobotEye, rarity: 'Rare', weight: 10 },
      { name: 'Key', img: Muses.Key, rarity: 'Epic', weight: 4 },
      { name: 'Alien Cyclops', img: Muses.BlackSpiky, rarity: 'Legendary', weight: 1 },
    ],
    dropRates: [60, 25, 10, 4, 1]
  },
  "Night Pack": {
    name: 'Night Pack',
    price: 10,
    description: 'Mysterious mythical beasts!',
    muses: [
      { name: 'Bat', img: Muses.Bat, rarity: 'Common', weight: 60 },
      { name: 'Ghost', img: Muses.Ghost, rarity: 'Uncommon', weight: 25 },
      { name: 'Wolf', img: Muses.Wolf, rarity: 'Rare', weight: 10 },
      { name: 'Potion', img: Muses.Potion, rarity: 'Epic', weight: 4 },
      { name: 'Pink Blob', img: Muses.PinkBlob, rarity: 'Legendary', weight: 1 },
    ],
    dropRates: [60, 25, 10, 4, 1]
  },
  "Sun Pack": {
    name: 'Sun Pack',
    price: 10,
    description: 'Bright and fiery muses!',
    muses: [
      { name: 'Bonfire', img: Muses.Bonfire, rarity: 'Common', weight: 60 },
      { name: 'Cool Sun', img: Muses.CoolSun, rarity: 'Uncommon', weight: 25 },
      { name: 'SmalSun', img: Muses.SmalSun, rarity: 'Rare', weight: 10 },
      { name: 'FireSpiky', img: Muses.FireSpiky, rarity: 'Epic', weight: 4 },
      { name: 'Sunbird', img: Muses.Sunbird, rarity: 'Legendary', weight: 1 },
    ],
    dropRates: [60, 25, 10, 4, 1]
  },
  "Forest Pack": {
    name: 'Forest Pack',
    price: 10,
    description: 'Nature and plant muses!',
    muses: [
      { name: 'Leaf', img: Muses.Leaf, rarity: 'Common', weight: 60 },
      { name: 'Berry', img: Muses.Berry, rarity: 'Uncommon', weight: 25 },
      { name: 'Rock', img: Muses.Rock, rarity: 'Rare', weight: 10 },
      { name: 'Red Helmet', img: Muses.RedHelmet, rarity: 'Epic', weight: 4 },
      { name: 'Gold Helmet', img: Muses.GoldHelmet, rarity: 'Legendary', weight: 1 },
    ],
    dropRates: [60, 25, 10, 4, 1]
  },




  "Friendly Pack 1": {
    name: 'Friendly Pack 1',
    price: 50,
    description: 'A lovable crew of friendly faces.',
    muses: [
      { name: 'Songly', img: Muses.Songly, rarity: 'Common', weight: 60 },
      { name: 'Lizzly', img: Muses.Lizzly, rarity: 'Uncommon', weight: 25 },
      { name: 'Marly', img: Muses.Marly, rarity: 'Rare', weight: 10 },
      { name: 'Puply', img: Muses.Puply, rarity: 'Epic', weight: 4 },
    ],
    dropRates: [60, 25, 10, 4]
  },
  "Arcade Pack 1": {
    name: 'Arcade Pack 1',
    price: 50,
    description: 'Characters from your favorite Overture games!',
    muses: [
      { name: 'Melopede C', img: Muses.MelopedeC, rarity: 'Common', weight: 60 },
      { name: 'Rocket Racer', img: Muses.RocketRacer, rarity: 'Uncommon', weight: 25 },
      { name: 'Melopede F & A', img: Muses.MelopedeFA, rarity: 'Rare', weight: 10 },
      { name: 'Bass Contender', img: Muses.BassContender, rarity: 'Epic', weight: 4 },
    ],
    dropRates: [60, 25, 10, 4]
  },
  "Celestial Pack 1": {
    name: 'Celestial Pack 1',
    price: 100,
    description: 'Muses from above the stratosphere!',
    muses: [
      { name: 'Sun', img: Muses.Sun, rarity: 'Common', weight: 60 },
      { name: 'Shooting Star', img: Muses.ShootingStar, rarity: 'Uncommon', weight: 25 },
      { name: 'Moon', img: Muses.Moon, rarity: 'Rare', weight: 10 },
      { name: 'Asteroid', img: Muses.Asteroid, rarity: 'Epic', weight: 4 },
    ],
    dropRates: [60, 25, 10, 4]
  },
  "Monster Pack 1": {
    name: 'Monster Pack 1',
    price: 500,
    description: 'Ghosts, ghouls, and other creatures of the night.',
    muses: [
      { name: 'Ghlowst', img: Muses.Ghlowst, rarity: 'Common', weight: 60 },
      { name: 'Batbuddy', img: Muses.Batbuddy, rarity: 'Uncommon', weight: 25 },
      { name: 'Skeleton', img: Muses.Skeleton, rarity: 'Rare', weight: 10 },
      { name: 'Imp', img: Muses.Imp, rarity: 'Epic', weight: 4 },
    ],
    dropRates: [60, 25, 10, 4]
  },
  "Outrageous Pack 1": {
    name: 'Outrageous Pack 1',
    price: 7500,
    description: 'Beautiful and bizarre variations on your favorite Muses.',
    muses: [
      { name: 'Battle Imp', img: Muses.BattleImp, rarity: 'Rare', weight: 60 },
      { name: 'Solar Eclipse', img: Muses.SolarEclipse, rarity: 'Epic', weight: 25 },
      { name: 'Golden Melopede', img: Muses.GoldMelopede, rarity: 'Epic', weight: 10 },
      { name: 'Mr. Moneybags', img: Muses.Moneybags, rarity: 'Epic', weight: 4 },
      { name: 'Inverted Songly', img: Muses.InvertedSongly, rarity: 'Epic', weight: 1 },
    ],
    dropRates: [60, 25, 10, 4, 1]
  },
};

export const getRandomMuse = (packName: string): Muse => {
  const pack = PACKS[packName];
  if (!pack) {
    throw new Error(`Pack "${packName}" not found`);
  }
  
  const muses = pack.muses;
  const total = muses.reduce((sum, m) => sum + (m.weight || 0), 0);
  let rand = Math.random() * total;
  
  for (const muse of muses) {
    const weight = muse.weight || 0;
    if (rand < weight) {
      return { ...muse, pack: packName };
    }
    rand -= weight;
  }
  
  return { ...muses[0], pack: packName };
};
